import {api} from "../../system/api";

export default {
    fetchShippingUsersSuggest: () => api.get('shipping-users/suggest')
}